/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TimelineHistory from '../../../../../../components/ui-elements/timeline/TimelineHistory';
import { Typography } from '@mui/material';
import { getAuthProviderHistory } from '../../../../../../store/reducers/authProvider/authProviderActions';

const AuthProviderHistory = ({ selectedAuthProvider }) => {
    const [historyList, setHistoryList] = useState([]);
    const authProviderHistory = useSelector(state => state.authProvider.authProviderHistory)
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getAuthProviderHistory({ "authProviderID": selectedAuthProvider.authProviderID }));
    }, [dispatch, selectedAuthProvider]);
    useEffect(() => {
        setHistoryList([]); // Clear the history list before setting new data
        if (authProviderHistory && authProviderHistory.length > 0) {
            // Ensure the data is in the correct format by using the model
            setHistoryList(authProviderHistory.map(item => ({
                ...item,
                Record: {
                    name: item.Record.authProviderName,
                    details: item.Record.authProviderDetails,
                    createdBy: item.Record.createdBy ?? "",
                    updatedBy: item.Record.updatedBy ?? "",
                }
            })));
        }
    }, [authProviderHistory]);

    return (
        <>
            <Typography variant="h3" align="center" color="success.light">Identity Provider  History</Typography>
            <TimelineHistory items={historyList} />
        </>
    )

}



export default AuthProviderHistory;